module.exports = __webpack_public_path__ + "img/ss.c14a7e29.png";